import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';

@Injectable()
export class DeviceService {
  private _deviceData: any = null;
  private _isInitialized: boolean = false;
  private _initPromise: Promise<any> = null;

  constructor(private http: HttpClient) {}

  public get deviceData(): any {
    return this._deviceData;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  /**
   * Executa a rota GET /api/v2/device/init ao acessar a rota de autenticação (/auth).
   */
  public initDevice(force: boolean = false): Promise<any> {
    if (this._isInitialized && !force) {
      return Promise.resolve(this._deviceData);
    }

    if (this._initPromise && !force) {
      return this._initPromise;
    }

    const apiBase = (environment.apiUrl || environment.baseUrl || '').replace(/\/+$/, '');
    const cleanUrl = `${apiBase}/api/v2/device/init`.replace(/([^:]\/)\/+/g, '$1');

    console.log('[DeviceService] Carregando /api/v2/device/init na rota /auth:', cleanUrl);

    this._initPromise = this.http.get(cleanUrl, {
      headers: {
        'X-Device-Context': 'asap_authorized_access'
      }
    })
      .toPromise()
      .then((response: any) => {
        console.log('[DeviceService] Dispositivo inicializado com sucesso:', response);
        this._deviceData = response;
        this._isInitialized = true;
        this._initPromise = null;
        return response;
      })
      .catch((error: any) => {
        console.error('[DeviceService] Erro ao inicializar dispositivo:', error);
        this._initPromise = null;
        return null;
      });

    return this._initPromise;
  }
}



// WEBPACK FOOTER //
// ./src/app/@core/services/device.service.ts